import React, { useRef, useEffect } from 'react';
import './Joints.scss';
import videomov from '../../../../assets/artemis/joints/artemis_joints_mobile.mov';
import video from '../../../../assets/artemis/joints/artemis_joints_mobile.webm';
import poster from '../../../../assets/artemis/joints/artemis_joints_mobile_poster.png';
import videomovD from '../../../../assets/artemis/joints/artemis_joints_desktop.mov';
import videoD from '../../../../assets/artemis/joints/artemis_joints_desktop.webm';
import posterD from '../../../../assets/artemis/joints/artemis_joints_desktop_poster.png';

function ArtemisJoints({ screenWidth }) {
  const videoDRef = useRef();
  const videoMRef = useRef();
  const jointsRef = useRef();
  const copyDRef = useRef();
  const copyMRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.6) {
              if (screenWidth > 480) {
                videoDRef.current.play();
                copyDRef.current.style.opacity = 1;
              } else {
                videoMRef.current.play();
                copyMRef.current.style.opacity = 1;
              }
            }
          }
        });
      },
      { threshold: [0, 0.6] }
    );
    observer.observe(jointsRef.current);
  }, [screenWidth]);

  return (
    <section className="joints joints-artemis">
      <p
        className="joints__animation__copy joints__animation__copy-artemis joints__animation__copy-desktop"
        ref={copyDRef}
      >
        The xEMU prototype has new shoulder placements to fit narrower shoulders, as well as
        reversible shoulder bearings that allow astronauts to reach across themselves and lift
        objects over their heads.
      </p>
      <div className="joints__animation joints__animation-contemporary" ref={jointsRef}>
        {screenWidth > 480 ? (
          <video
            muted
            playsInline
            preload="auto"
            ref={videoDRef}
            className="video"
            poster={posterD}
          >
            <source src={videomovD} type="video/quicktime" />
            <source src={videoD} type="video/webm" />
          </video>
        ) : (
          <video muted playsInline preload="auto" ref={videoMRef} className="video" poster={poster}>
            <source src={videomov} type="video/quicktime" />
            <source src={video} type="video/webm" />
          </video>
        )}

        <p
          className="joints__animation__copy joints__animation__copy-artemis joints__animation__copy-mobile"
          ref={copyMRef}
        >
          The xEMU prototype has new shoulder placements to fit narrower shoulders, as well as
          reversible shoulder bearings that allow astronauts to reach across themselves and lift
          objects over their heads.
        </p>
      </div>
    </section>
  );
}

export default ArtemisJoints;
